import * as React from 'react';

import {Avatar} from '../avatar/avatar';
import {colors} from '../colors/colors';
import {ChevronDown} from '../icon/svg/chevron-down-icon';
import {ContactsCircleIcon} from '../icon/svg/contacts-circle-icon';
import {Popover} from '../popover/popover';
import {SelectableListSingle} from '../selectable-list/selectable-list';

import styles from './user-select-button.module.css';

type Props = {
    selectedUserId: string | null | undefined;
    onSelect: (userId?: string | null | undefined) => void;
    users: any[];
    isSmall?: boolean;
    isReadOnly?: boolean;
    sortInitialValueToTop?: boolean;
};

export function UserSelectButton(props: Props) {
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const ref = React.useRef(null);

    if (!props.users) {
        return null;
    }

    const selectedUser = props.users.find((user) => user.id === props.selectedUserId);

    const Icon = selectedUser ? (
        <Avatar
            type='users'
            avatarUrl={selectedUser.avatarUrl}
            initials={selectedUser.initials}
            size={24}
            tooltipText={
                props.isReadOnly
                    ? undefined
                    : `Assigned to ${selectedUser.name} (click to reassign)`
            }
        />
    ) : (
        <div data-tip='Click to assign this thread'>
            {/* @ts-expect-error */}
            <ContactsCircleIcon color={colors.orangeDk} alignCenter={true} size={24} />
        </div>
    );

    const name = selectedUser ? selectedUser.name : 'Unassigned';

    return (
        <>
            <button
                // @ts-expect-error
                ref={(node) => (ref.current = node)}
                onClick={() => setIsPopoverOpen(true)}
                title={name}
                disabled={props.isReadOnly}
                className={styles.container}
            >
                {Icon}
                {props.isSmall ? undefined : <div>{name}</div>}
                {/* @ts-expect-error */}
                <ChevronDown color={colors.greyLt} alignCenter={true} size={12} />
            </button>
            {isPopoverOpen && ref && (
                <Popover
                    anchor={ref.current}
                    location='bottom'
                    onBlur={() => setIsPopoverOpen(false)}
                >
                    <div className={styles['form-body']}>
                        {/* @ts-expect-error */}
                        <SelectableListSingle
                            collection={props.users.map((user) => ({
                                id: user.id,
                                name: user.name,
                                avatarUrl: user.avatarUrl,
                                initials: user.initials,
                                type: 'users',
                            }))}
                            value={selectedUser && selectedUser.id}
                            hasSearch={true}
                            autoFocusSearch={true}
                            isNewStyle={true}
                            alwaysHasValue={true}
                            onSelect={(userId?: string | null) => {
                                props.onSelect(userId);
                                setIsPopoverOpen(false);
                            }}
                            // @ts-expect-error
                            sortInitialValueToTop={props.sortInitialValueToTop}
                        />
                    </div>
                </Popover>
            )}
        </>
    );
}
